export default async function GetVendorDetails() {
    let url = window.RealestateService+  `/api/Vendor/GetVendorDetails`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}